import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { SurveyScreen, SurveyListScreen, ManageSurveySectionsScreen, CreateSurveyScreen, SurveyResultsScreen, SurveyParticipantListScreen, SurveyQuestionResponseListScreen, EditSurveyScreen } from './../../screens';
import { MenuAction } from '../shared/sidebar.menu';


const Stack = createStackNavigator();

export const SurveyStack = ({ navigation, route }) => {
    console.log('export const SurveyStack = ({ navigation, route }) => {', {navigation, route});
    navigation.setOptions({ tabBarVisible: false });
    if (route.state) {
        navigation.setOptions({ tabBarVisible: route.state.index === 0 });
    }
    return (
        <Stack.Navigator initialRouteName='All'>
            <Stack.Screen
                name='All'
                component={SurveyListScreen}
                options={{
                    headerLeft: () => <MenuAction />,
                    // headerTitle: () => <HeaderLogo />,
                    headerTitle: '',
                    // headerRight: () => (
                    //     <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
                    //         <Button size='small' style={{ marginRight: 5 }} appearance='ghost' status='basic' onPress={() => navigation.navigate('Account', { actionType: 'login' })}>
                    //             Account
                    //         </Button>
                    //     </View>
                    // ),
                }}
            />
            <Stack.Screen name='Survey' component={SurveyScreen} options={{ title: 'Survey Details' }} />
            <Stack.Screen name='CreateSurvey' component={CreateSurveyScreen} options={{ title: 'Create Survey', headerStyle: { shadowOpacity: 0, elevation: 0 } }} />
            <Stack.Screen name='EditSurvey' component={EditSurveyScreen} options={{ title: 'Edit Survey' }} />
            <Stack.Screen name='ManageSurvey' component={ManageSurveySectionsScreen} options={{ title: 'Edit Survey' }} />
            <Stack.Screen name='SurveyResults' component={SurveyResultsScreen} options={{ title: 'Survey Results' }} />
            <Stack.Screen name='SurveyParticipantList' component={SurveyParticipantListScreen} options={{ title: 'Survey Participants' }} />
            <Stack.Screen name='SurveyQuestionResponseList' component={SurveyQuestionResponseListScreen} options={{ title: 'Question Responses' }} />
        </Stack.Navigator>
    )
};